import React, { useState } from 'react';
import './App.scss';
import { Routes, Route } from 'react-router-dom';
import Footer from './components/Footer';
import Header from './components/Header';
import AppViews from './components/AppViews';
import Home from './components/Home';

function App() {

  return (
    <>
      <Header />
      <Routes>
        <Route>
          <Route path="/*" element={<AppViews />} />
        </Route>
        <Route path="/" element={<Home />} />
      </Routes>
      <Footer />
    </>
  );
}

export default App;
